import React,{useState, useEffect} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';

import {Table} from 'reactstrap';
import DeleteIcon from '@material-ui/icons/Delete';
//form 
import axios from 'axios';

//notification
import {NotificationContainer,NotificationManager} from 'react-notifications';
import IntlMessages from 'util/IntlMessages';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function Cutomer(props) {
 const [open,setOpen] = useState(false);
    useEffect(() => {
        if(props.customeropen) {
         getCustomer();
         getSupplier();
          setOpen(true);
        }
    },[props.customeropen]) 
    
  const handleClose = () => {
    setOpen(false); 
  }

  useEffect(() => {
    if(!open){
      props.changeCutomer();
    }
   },[!open]) 
  

const [customer, setCustomer] = useState([]);
const [supplier, setSupplier] = useState([]);
  const getCustomer = () => {
    axios.get('api/customer')
      .then( res => {
            setCustomer(res.data)
            NotificationManager.success(<IntlMessages id="notification.successMessage"/>, <IntlMessages
            id="notification.titleHere" />);
          }
      ).catch( err =>{
            NotificationManager.error(<IntlMessages id="notification.errorMessage"/>, <IntlMessages
            id="notification.titleHere"/>);
          }
      )
  }

  const getSupplier = () => {
    axios.get('api/supplier')
      .then( res => {
            setSupplier(res.data)
            NotificationManager.success(<IntlMessages id="notification.successMessage"/>, <IntlMessages
            id="notification.titleHere" />);
          }
      ).catch( err =>{
            NotificationManager.error(<IntlMessages id="notification.errorMessage"/>, <IntlMessages
            id="notification.titleHere"/>);
          }
      )
  }

  const deleteCustomer = (id) => {
    axios.delete('api/customer/'+id)
    .then(res => {
        getCustomer();
       
        NotificationManager.success(<IntlMessages id="notification.successMessage"/>, <IntlMessages
        id="notification.titleHere" />);
      }
    ).catch( err =>{
      NotificationManager.error(<IntlMessages id="notification.errorMessage"/>, <IntlMessages
        id="notification.titleHere"/>);
    })  
  }

  const deleteSupplier = (id) => {
    axios.delete('api/supplier/'+id)
    .then(res => {
        getSupplier();
        NotificationManager.success(<IntlMessages id="notification.successMessage"/>, <IntlMessages
        id="notification.titleHere" />);
      }
    ).catch( err =>{
      NotificationManager.error(<IntlMessages id="notification.errorMessage"/>, <IntlMessages
        id="notification.titleHere"/>);
    })  
}
  return (
    <>
    <div>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="sm" fullWidth="sm">
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
         <div className="row">
         <div className="col-md-6">
            Customer
         </div>
         <div className="col-md-6">
            Supplier
         </div>
         </div>
        
        </DialogTitle>
        <DialogContent dividers>
          <div className="row">
           <div className="col-md-6">
          
                <div className="table-responsive-material">
                    <Table className="default-table table-unbordered table table-sm table-hover">
                      <thead className="table-head-sm th-border-b">
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Setting</th>
                      </tr>
                      </thead>
                      <tbody>
                      {customer.map((data, index) => {
                        return <tr key={index}>
                          <td>{index+1}</td>
                          <td>
                           {data.name}
                          </td>
                          
                          <td>
                            <div className="pointer text-primary">
                              <span className="d-inline-block mr-1">
                              <IconButton size="small" aria-label="Add Irradiation"  color="inherit" disabled={data.usertype ===1} 
                               onClick={() => deleteCustomer(data.id)}>
                                <DeleteIcon />
                              </IconButton>
                              </span>

                             
                            </div>
                          </td>
                        </tr>
                      })}
                      </tbody>
                    </Table>
                  </div>
              
           </div>

           <div className="col-md-6">
          
          <div className="table-responsive-material">
              <Table className="default-table table-unbordered table table-sm table-hover">
                <thead className="table-head-sm th-border-b">
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Setting</th>
                </tr>
                </thead>
                <tbody>
                {supplier.map((data, index) => {
                  return <tr key={index}>
                    <td>{index+1}</td>
                    <td>
                     {data.name}
                    </td>
                   
                    <td>
                      <div className="pointer text-primary">
                        <span className="d-inline-block mr-1">
                        <IconButton size="small" aria-label="Add Irradiation"  color="inherit" disabled={data.usertype ===1} 
                         onClick={() => deleteSupplier(data.id)}>
                          <DeleteIcon />
                        </IconButton>
                        </span>
                      </div>
                    </td>
                  </tr>
                })}
                </tbody>
              </Table>
            </div>
        
         </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
    <NotificationContainer/>
    </>
  );
}
